var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5106 5.4292H12.5137C13.6216 5.4292 14.5198 6.32737 14.5198 7.43533V12.6231C14.5198 13.731 13.6216 14.6292 12.5137 14.6292H3.48611C2.37815 14.6292 1.47998 13.731 1.47998 12.6231V7.43532C1.47998 6.32737 2.37815 5.4292 3.48611 5.4292H4.48917",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.99998,
    cy: 4.97239,
    r: 3.51072,
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91609 4.25431H8.47606C8.45094 4.00961 8.32014 3.78239 8.12871 3.64256H8.91609C8.96373 3.64256 9.00271 3.60323 9.00271 3.55517C9.00271 3.5071 8.96373 3.46777 8.91609 3.46777H7.0832C7.03556 3.46777 6.99658 3.5071 6.99658 3.55517C6.99658 3.60323 7.03556 3.64256 7.0832 3.64256H7.60812C7.965 3.64256 8.25951 3.91348 8.30195 4.25431H7.0832C7.03556 4.25431 6.99658 4.29363 6.99658 4.3417C6.99658 4.38977 7.03556 4.42909 7.0832 4.42909H8.30195C8.25864 4.78303 7.96067 5.04871 7.60812 5.04958H7.08407C7.03556 5.05046 6.99658 5.09066 6.99745 5.1396C6.99745 5.16319 7.00784 5.18591 7.0243 5.20252L8.33487 6.45311C8.36951 6.48632 8.42408 6.48457 8.457 6.44961C8.48992 6.41378 8.48818 6.35873 8.45354 6.32464L7.30062 5.22437H7.60726C8.05941 5.22437 8.43275 4.8748 8.47606 4.42909H8.91609C8.96373 4.42909 9.00271 4.38977 9.00271 4.3417C9.00271 4.29363 8.96373 4.25431 8.91609 4.25431Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.300919
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65341 8.62849H12.3466",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation);
export default __webpack_public_path__ + "static/media/donation.0fa65eb5a2c0f058806dfa3d1b13d292.svg";
export { ForwardRef as ReactComponent };